import Login from './Login';
import Logout from './Logout';
import EnterDrawTicket from './EnterDrawTicket';
import GetEntries from './GetEntries';
import GetPlayerData from './GetPlayerData';
import GetWinners from './GetWinners';
import Drawings from './Drawings';
import PostFeedback from '../FauxAPI/PostFeedback';
import GetCsrfToken from '../FauxAPI/GetCsrfToken';
import GetGame from '../FauxAPI/GetGame';
import GetGameOver from '../FauxAPI/GetGameOver';
import SetEntryFlashGameFlag from './SetEntryFlashGameFlag';
import GetJackpot from './GetJackpot';

export default {
    login: Login,
    logout: Logout,
    enterDrawTicket: EnterDrawTicket,
    getEntries: GetEntries,
    getPlayerData: GetPlayerData,
    getDrawings: Drawings,
    getWinners: GetWinners,
    getCsrfToken: GetCsrfToken,
    postFeedback: PostFeedback,
    getGame: GetGame,
    getGameOver: GetGameOver,
    setEntryFlashGameFlag: SetEntryFlashGameFlag,
    getJackpot: GetJackpot,
};
